// removed by extract-text-webpack-plugin
module.exports = {"panelIcon":"oAmJKsfoNl5t5Z3pXQhU2","flexRow":"dkV9s84O6QS5VjD4UNFLn","panelMin":"_2Pbp61VIdzhLc_Ij27Bq7d","btnSmall":"_2lmOochDRl7HYHr0VDbMHT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SourceDeck/SourceDeck.css
// module id = 378
// module chunks = 0